import React from 'react'
import { Modal, Row, Col, Button, Descriptions, Tag, Divider, Spin } from 'antd'
import { maskCurrency } from '../../utils/functions'
import moment from 'moment'

const CommissionDetailsModal = (props) => {
    const { visible, commission, loading, handleOk, handleCancel, handleApprove, handleReject, isSubmit } = props
    
    // Format the status with appropriate color tag
    const renderStatus = (status) => {
        if (status === 'pending') {
            return <Tag color="orange">Pendente</Tag>
        } else if (status === 'approved') {
            return <Tag color="green">Aprovado</Tag>
        } else if (status === 'rejected') {
            return <Tag color="red">Rejeitado</Tag>
        }
        return <Tag>{status}</Tag>
    }
    
    return (
        <Modal
            visible={visible}
            centered
            title="Detalhes da Comissão"
            onOk={handleOk}
            onCancel={handleCancel}
            width="70vw"
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Fechar
                </Button>,
                commission.status === 'pending' && (
                    <Button
                        key="approve"
                        type="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleApprove(commission.id);
                        }}
                        loading={isSubmit}
                        style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#ffffff' }}
                        className="btn-white-icon"
                        icon={
                            <svg viewBox="64 64 896 896" focusable="false" data-icon="check" width="1em" height="1em" fill="#ffffff" aria-hidden="true" style={{fill: '#ffffff', pointerEvents: 'none'}}>
                                <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" fill="#ffffff" style={{fill: '#ffffff', pointerEvents: 'none'}} />
                            </svg>
                        }
                    >
                        Aprovar
                    </Button>
                ),
                commission.status === 'pending' && (
                    <Button
                        key="reject"
                        type="primary"
                        danger
                        onClick={(e) => {
                            e.stopPropagation();
                            handleReject(commission.id);
                        }}
                        loading={isSubmit}
                        style={{ color: '#ffffff' }}
                        className="btn-white-icon"
                        icon={
                            <svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="#ffffff" aria-hidden="true" style={{fill: '#ffffff', pointerEvents: 'none'}}>
                                <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" fill="#ffffff" style={{fill: '#ffffff', pointerEvents: 'none'}} />
                            </svg>
                        }
                    >
                        Rejeitar
                    </Button>
                )
            ]}
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '30px' }}>
                    <Spin size="large" />
                </div>
            ) : (
                <div className="deny-info-wrapper">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} md={12} className="border">
                            <Descriptions title="Informações da Comissão" bordered column={1}>
                                <Descriptions.Item label="ID">{commission.id}</Descriptions.Item>
                                <Descriptions.Item label="Nível">{commission.level}</Descriptions.Item>
                                <Descriptions.Item label="Porcentagem">
                                    {typeof commission.percentage === 'string' 
                                        ? `${parseFloat(commission.percentage).toFixed(2)}%` 
                                        : `${commission.percentage?.toFixed(2)}%`}
                                </Descriptions.Item>
                                <Descriptions.Item label="Valor do Contrato">R$ {maskCurrency(commission.contractValue)}</Descriptions.Item>
                                <Descriptions.Item label="Valor da Comissão">R$ {maskCurrency(commission.commissionValue)}</Descriptions.Item>
                                <Descriptions.Item label="Status">{renderStatus(commission.status)}</Descriptions.Item>
                                <Descriptions.Item label="Data de Criação">{moment(commission.createdAt).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                                <Descriptions.Item label="Última Atualização">{moment(commission.updatedAt).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                            </Descriptions>
                            
                            {commission.approvedAt && (
                                <div style={{ marginTop: '20px' }}>
                                    <Descriptions title="Informações da Aprovação" bordered column={1}>
                                        <Descriptions.Item label="Aprovado Por">ID: {commission.approvedBy}</Descriptions.Item>
                                        <Descriptions.Item label="Data da Aprovação">{moment(commission.approvedAt).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                                    </Descriptions>
                                </div>
                            )}
                            
                            {commission.rejectionReason && (
                                <div style={{ marginTop: '20px' }}>
                                    <Descriptions title="Motivo da Rejeição" bordered column={1}>
                                        <Descriptions.Item label="Motivo">{commission.rejectionReason}</Descriptions.Item>
                                    </Descriptions>
                                </div>
                            )}
                        </Col>
                        
                        <Col xs={24} md={12}>
                            <Descriptions title="Informações do Referenciador" bordered column={1}>
                                <Descriptions.Item label="ID">{commission.referrer?.id}</Descriptions.Item>
                                <Descriptions.Item label="Nome">{commission.referrer?.nome}</Descriptions.Item>
                                <Descriptions.Item label="Email">{commission.referrer?.email}</Descriptions.Item>
                                <Descriptions.Item label="Telefone">{commission.referrer?.telefone}</Descriptions.Item>
                                <Descriptions.Item label="Código de Referência">{commission.referrer?.referralCode}</Descriptions.Item>
                            </Descriptions>
                            
                            <Divider />
                            
                            <Descriptions title="Informações do Cliente" bordered column={1}>
                                <Descriptions.Item label="ID">{commission.client?.id}</Descriptions.Item>
                                <Descriptions.Item label="Nome">{commission.client?.nome}</Descriptions.Item>
                                <Descriptions.Item label="Email">{commission.client?.email}</Descriptions.Item>
                            </Descriptions>
                            
                            <Divider />
                            
                            <Descriptions title="Informações do Contrato" bordered column={1}>
                                <Descriptions.Item label="ID">{commission.contract?.id}</Descriptions.Item>
                                <Descriptions.Item label="Valor Inicial">R$ {maskCurrency(commission.contract?.valorInicial)}</Descriptions.Item>
                                <Descriptions.Item label="Data de Início">{moment(commission.contract?.dataInicio).format('DD/MM/YYYY')}</Descriptions.Item>
                                <Descriptions.Item label="Data de Fim">{moment(commission.contract?.dataFim).format('DD/MM/YYYY')}</Descriptions.Item>
                                <Descriptions.Item label="Status do Contrato">{commission.contract?.status}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                </div>
            )}
        </Modal>
    )
}

export default CommissionDetailsModal 